{
  "cms.unpublish.success": "Unpublished.",
  "cms.archive.success": "Archived.",
  "cms.schedule.success.saved": "Schedule saved.",
  "cms.schedule.success.changed": "Schedule changed.",
  "cms.schedule.success.cancelled": "Schedule cancelled.",
  "cms.order.success.published": "Order published.",
  "cms.order.success.discarded": "Order change discarded."
}
